export const TAG_COLORS = [
	'#1abc9c',
	'#2ecc71',
	'#3498db',
	'#27ae60',
	'#34495e',
	'#16a085',
	'#2980b9',
	'#8e44ad',
	'#2c3e50',
	'#f1c40f',
	'#e67e22',
	'#e74c3c',
	'#ecf0f1',
	'#95a5a6',
	'#f39c12',
	'#d35400'
];
